/**
 * Tab ID utility for correlating requests from the same browser tab.
 *
 * Generates a UUID when a new tab is opened and stores it in sessionStorage.
 * The ID persists across page reloads within the same tab but is unique per tab.
 */

const TAB_ID_STORAGE_KEY = 'x-tab-id';

/**
 * Generates a UUID v4 string.
 */
function generateUUID(): string {
  return crypto.randomUUID();
}

/**
 * Gets or creates a unique tab ID.
 * The ID is stored in sessionStorage so it persists across page reloads
 * but is unique for each browser tab.
 */
export function getTabId(): string {
  let tabId = sessionStorage.getItem(TAB_ID_STORAGE_KEY);

  if (!tabId) {
    tabId = generateUUID();
    sessionStorage.setItem(TAB_ID_STORAGE_KEY, tabId);
  }

  return tabId;
}
